// extracted by mini-css-extract-plugin
export default {"wrapper":"checkbox_wrapper__zI0ge","inputStyle":"checkbox_inputStyle__Rjg8M"};